import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Form } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { saveRoleData, updateRoleData, getRoleListById,getRoleList } from "../../redux/actions/RoleActions";
import FormInput from "../../Components/FormInput";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import HyperDatepicker from "../../Components/Datepicker";
import { getDateTimeMysqlGivenFormatYmd } from '../../util/generalUtills'
import Preloader from "../../Components/Preloader";
import Status from "../../enums/Status";

const Dashboard = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({});
  const [stateId, setStateId] = useState(null);
    const [fieldErrors, setFieldErrors] = useState(null);

  
  
  const [showReporting, setShowReporting] = useState(false);
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    RoleReducer: {
       roleList,
    roleStatus,
    changedroleStatus,
    loadingRole,
    errorsRole,
    roleCount,
    },
  
  } = useSelector((state) => state);

  useEffect(() => {
    if (auth?.accessToken && !id) {
      dispatch(getRoleList(auth?.accessToken));
    }
  }, [auth?.accessToken, id]);

 


  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if (id) {
      dispatch(updateRoleData(auth?.accessToken, formData, id));
    }
    else {
      dispatch(saveRoleData(auth?.accessToken, formData));
    }
  };

  useEffect(() => {
    if (id) {
      dispatch(getRoleListById(auth?.accessToken, id));
    }
  }, [auth?.accessToken, id]);

  useEffect(() => {
    if (id && roleList && !Array.isArray(roleList) && roleList?.roleName) {
      setFormData({
        roleName: roleList?.roleName,
        roleCode: roleList?.roleCode,
        status: roleList?.status,
      });
    }
  }, [id, roleList]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      if (errors?.status === 401) {
        dispatch(logout());
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errors, dispatch, navigate]);

  useEffect(() => {
    if (errorsRole && Object.keys(errorsRole).length > 0) {
      if (errorsRole?.status === 409) {
        swal.fire({
          show: true,
          title: "Oops!",
          text: errorsRole?.data?.message,
          icon: "error",
          showConfirmButton: false,
          timer: 1500
        });
        dispatch({ type: 'RESET_DELETE_USER_STATUS' });
      } else if (errorsRole?.status === 400) {
        // Handle other status
            if (errorsRole?.data?.errors && Array.isArray(errorsRole.data.errors)) {
          const transformedErrors = {};
          errorsRole.data.errors.forEach(error => {
            if (error.field && error.message) {
              transformedErrors[error.field] = error.message;
            }
          });
          setFieldErrors(transformedErrors);
        }
      } else {
        dispatch({ type: 'RESET_DELETE_USER_STATUS' });
      }
    }
  }, [errorsRole, dispatch]);

  useEffect(() => {
    if (changedroleStatus?.message) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedroleStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_USER_STATUS' });
      navigate(-1);
    }
  }, [changedroleStatus, dispatch, navigate]);

  
  useEffect(() => {
    if (!id) {
      setFormData({});
    }
    dispatch({ type: 'RESET_DELETE_USER_STATUS' });
  }, [dispatch, id]);

  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const inputHandlerCaps = (e) => {
    const { value, name } = e.target;
    const processedValue = value.replace(/\s+/g, '').toUpperCase(); // Remove spaces and convert to uppercase
    setFormData({ ...formData, [name]: processedValue });
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };





  const selectHandler = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData[0].value,
    }));
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const selectHandler2 = (selectedData, name) => {

    const selectedId = selectedData[0]?.state_code;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedId
    }));
  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errorsRole?.data?.username ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errorsRole?.data?.username? 'red' : base.borderColor,
      }
    }),
  };


  useEffect(()=>{
    setFieldErrors({})

  },[navigate]);



  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Role"), path: "Role" },
          { label: id ? t("Update Role") : t("Add Role"), path: "/Add-Role", active: true },
        ]}
        title={id ? t("Update Role") : t("Add Role")}
      />
      <Row>
           <Col lg={4}></Col>
        <Col lg={4}>
          <Card>
            <Card.Body>
              {errors?.data?.message && (
                <div className="alert alert-danger">
                  {errors.data.message}
                </div>
              )}
              <Row>
            

                
                  <FormInput
                    label={t("Role Code")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.roleCode}
                    name="roleCode"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                

                
                  <FormInput
                    label={t("Role Name")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.roleName}
                    name="roleName"
                    onChange={inputHandlerCaps}
                    containerClass={"mb-3"}
                  />
                
                 <Form.Group className="mb-3">
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <Form.Label className="mb-0">{t("Status")}</Form.Label>
                                  <Form.Check
                                    type="switch"
                                    id="status-switch"
                                    label={formData.status === Status.ACTIVE ? t("Active") : t("Inactive")}
                                    checked={formData.status === Status.ACTIVE}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        status: e.target.checked ? Status.ACTIVE : Status.INACTIVE
                                      });
                                    }}
                                  />
                                </div>
                              </Form.Group>


              </Row>

              <div className="d-flex justify-content-center">
                {loadingRole ?
                  <Button color="primary" disabled>
                    <Spinner
                      className="spinner-border-sm me-1"
                      tag="span"
                      color="white"
                    />
                    Please wait ...
                  </Button>
                  :
                  <Button type="button" onClick={handleSubmit} disabled={loadingRole}>
                    Submit
                  </Button>
                }
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingRole && (<Preloader />)}
    </>
  );
};

export default Dashboard;
